<template>
  <section class="travel-quote-info">
    <div class="box">
      <table class="table mg-b-10">
        <tr class="tr">
          <td>Insured Period</td>
          <td
            v-copy="formData.insurance_period"
            :class="{'green-tip':handleCompare('insurance_period')}" >{{ formData.insurance_period}}</td>
        </tr>
        <tr class="tr">
          <td>Expected Insured Period</td>
          <td
            v-copy="formData.period_date"
            :class="{'green-tip':handleCompare('period_date')}">
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </td>
        </tr>
        <tr class="tr">
          <td>Total Payable</td>
          <td
            v-if="showAmount"
            v-copy="amount"
            :class="{'green-tip':isChange}">{{ showAmount | formatMoney(2, true) }}</td>
        </tr>
        <tr class="tr">
          <td>Referrer</td>
          <td
            v-if="referrer"
          >
            <referrer-info :referrer="referrer"></referrer-info>
          </td>
        </tr>
        <tr
          v-if="formData.discount_str&&!isFina"
          class="tr">
          <td>Referrer Discount</td>
          <td>{{formData.discount_str}}</td>
        </tr>
        <tr
          v-if="!isEndorse"
          class="tr">
          <td>Policy Number </td>
          <td
            v-copy="formData.pcy_no"
            :class="{'green-tip':handleCompare('pcy_no')}">{{ formData.pcy_no  }}</td>
        </tr>
        <tr
          v-else
          class="tr">
          <td>Endorsement Number </td>
          <td
            v-copy="formData.endorser_no"
            :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</td>
        </tr>
        <tr class="tr">
          <td>Policy Reference Code </td>
          <td
            v-copy="formData.order_sn"
            :class="{'green-tip':handleCompare('order_sn')}">{{ formData.order_sn }}</td>
        </tr>
      </table>
    </div>
    <div
      v-if="excessList.length"
      class="box">
      <h3>Excess</h3>
      <table class="table">
        <tr class="tr th">
          <th>Item</th>
          <th>Amount</th>
        </tr>
        <tr
          v-for="(inItem, index) in excessList"
          :key="index + inItem.premium"
          class="tr">
          <td>{{ inItem.item }}</td>
          <td
            v-copy=" inItem.premium"
          >{{ inItem.premium }}</td>
        </tr>
        <tr class="tr">
          <td>Excess Remark</td>
          <td
            v-copy="changeLineData(formData.quote_remark)"
            :class="{'green-tip':handleCompare('quote_remark')}"
            v-html="changeLineData(formData.quote_remark)"></td>
        </tr>
      </table>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in coverageList.items"
        :key="'coverage' + excessIndex">
        <table
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
          <tr
            v-if="excessIndex==0"
            class="tr th">
            <th>Item</th>
            <th>Information</th>
          </tr>
          <tr
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <td>{{ subItem.item }}</td>
            <td
              v-copy="subItem.premium"
            >{{ subItem.premium }}</td>
          </tr>
          <tr class="tr">
            <td>Coverage Remark</td>
            <td
              v-copy="changeLineData(formData.cvr_remark)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(formData.cvr_remark)"></td>
          </tr>
        </table>
      </div>
    </div>
    <div class="box">
      <h2>Policy Detail</h2>
      <table class="table mg-b-10">
        <tr class="tr">
          <td>Expected Effective Date</td>
          <td
            v-copy="formData.pcy_cmnt_dt"
            :class="{'green-tip':handleCompare('pcy_cmnt_dt')}">{{ formData.pcy_cmnt_dt }}</td>
        </tr>
        <tr class="tr">
          <td>Expected Expiry Date</td>
          <td
            v-copy="formData.pcy_expry_date"
            :class="{'green-tip':handleCompare('pcy_expry_date')}">{{ formData.pcy_expry_date }}</td>
        </tr>
        <tr class="tr">
          <td>Studying Country</td>
          <!--          <span>{{ getAllOptionName25('study_country',formData.country_id) }}</span>-->
          <td
            v-if="formData.country_id!=3"
            v-copy="getAllOptionName25('study_country',formData.country_id)"
            :class="{'green-tip':handleCompare('country_id')}">{{getAllOptionName25('study_country',formData.country_id)}}</td>
          <td
            v-else
            v-copy="other_country"
            :class="{'green-tip':handleCompare('country_id')}">{{getAllOptionName25('study_country',formData.country_id)}} - {{formData.other_country}}</td>

        </tr>
      </table>
    </div>

    <div class="box">
      <h2>Policyholder Detail</h2>
      <table class="table">
        <tr class="tr">
          <td>Title</td>
          <td
            v-copy="getOptionName('titleOptions', formData.isrd_title)"
            :class="{'green-tip':handleCompare('isrd_title')}">{{ getOptionName('titleOptions', formData.isrd_title) }}</td>
        </tr>
        <tr class="tr">
          <td>Last Name</td>
          <td
            v-copy="formData.isrd_lst_nm"
            :class="{'green-tip':handleCompare('isrd_lst_nm')}">{{ formData.isrd_lst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>First Name</td>
          <td
            v-copy="formData.isrd_fst_nm"
            :class="{'green-tip':handleCompare('isrd_fst_nm')}">{{ formData.isrd_fst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>Date of Birth</td>
          <td
            v-copy="formData.isrd_dob_date"
            :class="{'green-tip':handleCompare('isrd_dob_date')}">{{ formData.isrd_dob_date }}</td>
        </tr>
        <tr class="tr">
          <td>Mobile Number</td>
          <td
            v-copy="formData.mobile_no"
            :class="{'green-tip':handleCompare('mobile_no')}">{{ formData.mobile_no }}</td>
        </tr>
        <tr class="tr">
          <td>HKID Number</td>
          <td
            v-copy="formData.id_no"
            :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</td>
        </tr>
        <tr class="tr">
          <td>Email</td>
          <td
            v-copy="formData.email"
            :class="{'green-tip':handleCompare('email')}">
            {{ formData.email }}
            <email-tooltip :email="formData.email"></email-tooltip>
          </td>
        </tr>
        <tr class="tr">
          <td>Occupation</td>
          <td
            v-copy="formData.occ"
            :class="{'green-tip':handleCompare('occ')}">{{ formData.occ }}</td>
        </tr>
        <tr class="tr">
          <td>Policyholder and student is the same person?</td>
          <td
            v-copy="getOptionName('yesNoOptions',formData.hldr_is_student_ind)"
            :class="{'green-tip':handleCompare('hldr_is_student_ind')}">{{getOptionName('yesNoOptions',formData.hldr_is_student_ind)}}</td>
        </tr>
      </table>
      <h3>Correspondence Address</h3>
      <table class="table">
        <tr class="tr">
          <td>Room</td>
          <td
            v-copy="formData.addr_room"
            :class="{'green-tip':handleCompare('addr_room')}">{{ formData.addr_room }}</td>
        </tr>
        <tr class="tr">
          <td>Floor</td>
          <td
            v-copy="formData.addr_floor"
            :class="{'green-tip':handleCompare('addr_floor')}">{{ formData.addr_floor }}</td>
        </tr>
        <tr class="tr">
          <td>Block</td>
          <td
            v-copy="formData.addr_block"
            :class="{'green-tip':handleCompare('addr_block')}">{{ formData.addr_block }}</td>
        </tr>
        <tr class="tr">
          <td>Building / Estate</td>
          <td
            v-copy="formData.addr_building"
            :class="{'green-tip':handleCompare('addr_building')}">{{ formData.addr_building }}</td>
        </tr>
        <tr class="tr">
          <td>Street</td>
          <td
            v-copy="formData.addr_street"
            :class="{'green-tip':handleCompare('addr_street')}">{{ formData.addr_street }}</td>
        </tr>
        <tr class="tr">
          <td>District</td>
          <td
            v-copy="getAreaName('district', formData.addr_district)"
            :class="{'green-tip':handleCompare('addr_district')}">{{ getAreaName('district', formData.addr_district) }}</td>
        </tr>
        <tr class="tr">
          <td>Area</td>
          <td
            v-copy="getAreaName('area', formData.addr_area)"
            :class="{'green-tip':handleCompare('addr_area')}">{{ getAreaName('area', formData.addr_area) }}</td>
        </tr>
        <tr class="tr">
          <td>Country / Region</td>
          <td
            v-copy="getAreaName('region', formData.addr_region)"
            :class="{'green-tip':handleCompare('addr_region')}">{{ getAreaName('region', formData.addr_region) }}</td>
        </tr>

      </table>

    </div>

    <div class="box">
      <h2>Insured Student Details</h2>
      <table class="table">
        <tr class="tr">
          <td>Title</td>
          <td
            v-copy="getOptionName('titleOptions', student_info.student_title)"
            :class="{'green-tip':compareChange('student_info','student_title')}">{{ getOptionName('titleOptions', student_info.student_title) }}</td>
        </tr>
        <tr class="tr">
          <td>Last Name</td>
          <td
            v-copy="student_info.student_lst_nm"
            :class="{'green-tip':compareChange('student_info','student_lst_nm')}">{{ student_info.student_lst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>First Name</td>
          <td
            v-copy="student_info.student_fst_nm"
            :class="{'green-tip':compareChange('student_info','student_fst_nm')}">{{  student_info.student_fst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>HKID</td>
          <td
            v-copy="student_info.student_id_no"
            :class="{'green-tip':compareChange('student_info','student_id_no')}">{{  student_info.student_id_no}}</td>
        </tr>
        <tr class="tr">
          <td>Date of Birth</td>
          <td
            v-copy="student_info.student_dob"
            :class="{'green-tip':compareChange('student_info','student_dob')}">{{ student_info.student_dob }}</td>
        </tr>
        <tr class="tr">
          <td>Relationship</td>
          <td
            v-copy="student_info.student_rel_language"
            :class="{'green-tip':compareChange('student_info','student_rel_language')}">{{ student_info.student_rel_language}}</td>
        </tr>
        <tr class="tr">
          <td>Overseas Studying Institution Name</td>
          <td
            v-copy="student_info.student_ins_nm"
            :class="{'green-tip':compareChange('student_info','student_ins_nm')}">{{  student_info.student_ins_nm}}</td>
        </tr>
        <tr class="tr">
          <td>Overseas Studying Institution Address</td>
          <td
            v-copy="student_info.student_addr"
            :class="{'green-tip':compareChange('student_info','student_addr')}">{{ student_info.student_addr}}</td>
        </tr>
      </table>
    </div>
    <div
      v-if="hasAcc"
      class="box">
      <h2>Accompanying Parent or Guardian Details</h2>
      <table class="table">
        <tr class="tr">
          <td>Title</td>
          <td
            v-copy="getOptionName('titleOptions', acc_parent_info.student_title)"
            :class="{'green-tip':compareChange('acc_parent_info','student_title')}">{{ getOptionName('titleOptions', acc_parent_info.student_title) }}</td>
        </tr>
        <tr class="tr">
          <td>Last Name</td>
          <td
            v-copy="acc_parent_info.accompanying_lst_nm"
            :class="{'green-tip':compareChange('acc_parent_info','accompanying_lst_nm')}">{{ acc_parent_info.accompanying_lst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>First Name</td>
          <td
            v-copy="acc_parent_info.accompanying_fst_nm"
            :class="{'green-tip':compareChange('acc_parent_info','accompanying_fst_nm')}">{{  acc_parent_info.accompanying_fst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>HKID</td>
          <td
            v-copy="acc_parent_info.accompanying_id_no"
            :class="{'green-tip':compareChange('acc_parent_info','accompanying_id_no')}">{{  acc_parent_info.accompanying_id_no}}</td>
        </tr>
        <tr class="tr">
          <td>Date of Birth</td>
          <td
            v-copy="acc_parent_info.accompanying_dob"
            :class="{'green-tip':compareChange('acc_parent_info','accompanying_dob')}">{{acc_parent_info.accompanying_dob }}</td>
        </tr>
        <tr class="tr">
          <td>Relationship to Policyholder</td>
          <td
            v-copy="acc_parent_info.accompanying_rel_language"
            :class="{'green-tip':compareChange('acc_parent_info','accompanying_rel_language')}">{{ acc_parent_info.accompanying_rel_language}}</td>
        </tr>
      </table>
    </div>
    <div class="box">
      <h3>Remark(s)</h3>
      <table class="table">
        <tr class="tr">
          <td>Remark</td>
          <td
            v-copy="remark('quote_remark')"
            :class="{'green-tip':handleCompare('quote_remark')}">{{ remark('quote_remark') }}</td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'
import OMath from '@/utils/math'
import ReferrerInfo from '@/views/records/policy/components/info/referrer-info'

export default {
  name: 'StudentPolicyDetailInfo',
  components: {ReferrerInfo},
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    isFina(){
      let {merchant_platform} = this.formData||{}
      return merchant_platform==2
    },
    amount(){
      return  OMath.formatMoney(this.showAmount, 2,true)
    },
    other_country(){
      let {other_country,country_id} = this.formData||{}
      return `${this.getAllOptionName25('study_country',country_id)} - ${other_country}`
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    sidebarPremium() {
      let {quote_coverage_list={}} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        if(period_of_cvr >= 1) {
          return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
        }
        else {
          return dayjs(pcy_cmnt_dt).add(Number(period_of_cvr)*10, 'months').format('YYYY-MM-DD')
        }
        // return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    localAllOptions() {
      return this.allOptions25
    },
    student_info() {
      let {student_info}= this.formData||{}
      return student_info||{}
    },
    acc_parent_info() {
      let {acc_parent_info}= this.formData||{}
      return acc_parent_info||{}
    },
    hasAcc() {
      let {benefits=[]}= this.formData||{}
      return benefits.includes(2)
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage={}} = quote_coverage_list||{}
      return  coverage
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    },
    compareChange(){
      return (name,field)=>{
        let data = this[name]
        let pre = this.preFormData||{}
        let {type} = this.formData||{}
        let preData =pre[name]||{}
        if(type!=50)return  false
        return preData[field]!=data[field]||false
      }
    }
  },
  watch: {
    'formData.nationality_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.updateNationalityOptions(val)
        }
      }
    }
  },
  methods: {
    ...mapActions('common', ['updateNationalityOptions']),
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    remark(name){
      let data = this.formData[name]||''
      return data?data.replace(/\n/g, '<br/>'):'-'
    }
  }
}
</script>
<style lang="scss" scoped>
.housemaid-quote-info{
  .box {
    margin-bottom: 15px;
  }
  .title {
    display: block;
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
}
.asap{
  font-weight: bold;
  color: black;
  margin-left: 5px;
}
</style>
